export default "__VITE_ASSET__acbb2594__"